import { TranslateService } from "@ngx-translate/core";
import { Translation } from "primeng/api";
import { PrimeNG } from "primeng/config";

const PRIMENG_I18N_KEY = "primeng";

/** Applies PrimeNG locale from the `primeng` block in en.json / el.json. */
export function applyPrimeNgLocaleFromTranslations(
    translate: TranslateService,
    primeNG: PrimeNG,
): void {
    translate.get(PRIMENG_I18N_KEY).subscribe((locale) => {
        if (locale && typeof locale === "object") {
            primeNG.setTranslation(locale as Translation);
        }
    });
}
